import { paymentDiscountTypeSchema } from "../../../../payment/discount.mjs";
import { extraPackageGroupSchema, extraPackageSkuMarketingMetadataSchema, extraPackageSkuPackageContentsSchema, extraPackageSkuTierValuesSchema } from "../../../../payment/extraPackageSku.mjs";
import { extraPackageValueSchema } from "../../../../payment/item/boost.mjs";
import { paymentItemPromotionSchema } from "../../../../payment/item/promotion.mjs";
import { OneTimePurchaseProviders, currencySchema, oneTimePurchaseOptionsSchema, providerResultSchema } from "../../../../payment/shared.mjs";
import { orderSchema } from "../../order/schemas.mjs";
import { z } from "zod";
//#region src/api/orpc/payment/extraPackage/schemas.ts
const priceMicrosSchema = z.coerce.bigint();
const supportedProviderSchema = z.enum(OneTimePurchaseProviders);
const extraPackageSkuSchema = z.object({
	id: z.uuid(),
	legacyItemId: z.string(),
	name: z.string(),
	currency: currencySchema,
	priceMicros: priceMicrosSchema,
	originalPriceMicros: priceMicrosSchema.nullable(),
	displayAmount: z.string(),
	supportedProviders: z.array(supportedProviderSchema),
	webProductName: z.string().nullable(),
	appStoreProductId: z.string().nullable(),
	googlePlayProductId: z.string().nullable(),
	tierValues: extraPackageSkuTierValuesSchema,
	packageContents: extraPackageSkuPackageContentsSchema.nullable(),
	boostNameBlacklist: z.array(z.string()),
	oneTimePurchase: z.boolean(),
	monthlyPurchase: z.boolean(),
	supportUserSource: z.array(z.string()),
	marketingMetadata: extraPackageSkuMarketingMetadataSchema.nullable(),
	activeSince: z.iso.datetime().nullable(),
	deactivatedAt: z.iso.datetime().nullable(),
	sortOrder: z.int(),
	groupId: z.uuid().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	lastOperatorId: z.coerce.bigint().nullable()
});
const paymentDiscountSchema = z.object({
	id: z.string().min(1),
	name: z.string(),
	type: paymentDiscountTypeSchema,
	value: z.coerce.bigint(),
	activeSince: z.iso.datetime().nullable(),
	deactivatedAt: z.iso.datetime().nullable(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
	lastOperatorId: z.coerce.bigint().nullable()
});
const discountTargetSchema = z.object({
	id: z.uuid(),
	discountId: z.string().min(1),
	extraPackageSkuId: z.uuid(),
	appStoreOfferId: z.string().nullable(),
	googlePlayOfferId: z.string().nullable(),
	createdAt: z.iso.datetime()
});
const userExtraPackageSkuSchema = extraPackageSkuSchema.extend({
	promotions: z.array(paymentItemPromotionSchema),
	tierBoosts: z.array(extraPackageValueSchema)
});
const promotionOptionSchema = z.object({ extraPackageBoostCode: z.string().trim().optional() }).optional();
const purchaseInputSchema = oneTimePurchaseOptionsSchema.extend({
	skuId: z.uuid(),
	promotionOption: promotionOptionSchema
});
const purchaseResultSchema = z.object({
	orderId: z.coerce.bigint(),
	provider: z.enum(OneTimePurchaseProviders),
	providerResult: providerResultSchema.optional()
});
const listExtraPackageSkusInputSchema = z.object({
	currency: currencySchema.optional(),
	groupId: z.uuid().optional(),
	promotionOption: promotionOptionSchema
});
const getExtraPackageSkuInputSchema = z.object({
	skuId: z.uuid(),
	promotionOption: promotionOptionSchema
});
const confirmWebInputSchema = z.object({ orderId: z.coerce.bigint() });
const confirmAppleInputSchema = z.object({
	orderId: z.coerce.bigint(),
	transactionId: z.string().min(1)
});
const confirmGoogleInputSchema = z.object({
	orderId: z.coerce.bigint(),
	purchaseToken: z.string().min(1),
	productId: z.string().min(1),
	googleOrderId: z.string().optional()
});
const confirmResponseSchema = z.object({ order: orderSchema });
const userExtraPackageGroupSchema = extraPackageGroupSchema.pick({
	id: true,
	key: true,
	name: true,
	sortOrder: true
});
const listExtraPackageGroupsInputSchema = z.object({}).optional();
//#endregion
export { confirmAppleInputSchema, confirmGoogleInputSchema, confirmResponseSchema, confirmWebInputSchema, discountTargetSchema, extraPackageSkuSchema, getExtraPackageSkuInputSchema, listExtraPackageGroupsInputSchema, listExtraPackageSkusInputSchema, paymentDiscountSchema, purchaseInputSchema, purchaseResultSchema, userExtraPackageGroupSchema, userExtraPackageSkuSchema };
